import { useQuery } from '@tanstack/react-query';

import { REACT_APP_API_FETCH_INTERVAL } from '#shared';

import { weatherApi } from '../aviationWeather.api';

import type { AirSigmet, TPoint } from '#entities';

const transform = (raw: string) => {
  const rows = raw.split('\n');
  if (rows.length < 6) {
    throw new Error('Corrupted CSV file');
  }
  const rawData = rows.slice(6);

  const data: AirSigmet[] = rawData
    .filter(i => !!i)
    .map(row => {
      const [
        rawText,
        validTimeFrom,
        validTimeTo,
        rawLonLatPoints,
        minFtMsl,
        maxFtMsl,
        movementDirDegrees,
        movementSpeedKt,
        hazard,
        severity,
        airsigmetType,
      ] = row.split(',');
      const lonLatPoints: TPoint[] = rawLonLatPoints
        ? rawLonLatPoints.split(';').map(s => {
            const [lon, lat] = s.split(':');
            return [parseFloat(lon), parseFloat(lat)] as TPoint;
          })
        : [];

      return {
        rawText,
        validTimeFrom,
        validTimeTo,
        lonLatPoints,
        minFtMsl,
        maxFtMsl,
        movementDirDegrees,
        movementSpeedKt,
        hazard: hazard as AirSigmet['hazard'],
        severity: severity as AirSigmet['severity'],
        airsigmetType: airsigmetType as AirSigmet['airsigmetType'],
      };
    });
  return data;
};

export const useQueryAirSigmets = () =>
  useQuery({
    queryKey: ['weather', 'airSigmets'],
    queryFn: weatherApi.getISegmet,
    select: transform,
    refetchInterval: 1000 * REACT_APP_API_FETCH_INTERVAL,
    refetchIntervalInBackground: true,
  });
